
import { CsvUtilFileUpload } from "@/features/csv-utils/components/FileUpload";
import { AnalysisDashboard } from "@/features/csv-utils/components/analysis/AnalysisDashboard";
import { CsvUtilLayout } from "@/features/csv-utils/components/layout/CsvUtilLayout";
import { CsvUtilHeader } from "@/features/csv-utils/components/layout/CsvUtilHeader";
import { SectionWrapper } from "@/features/csv-utils/components/layout/SectionWrapper";
import { ExportFundData } from "@/components/research/ExportFundData";
import { FundResearch } from "@/features/csv-utils/components/FundResearch";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const CsvUtilsPage = () => {
  return (
    <CsvUtilLayout>
      <CsvUtilHeader />
      
      <Tabs defaultValue="analysis" className="space-y-4">
        <TabsList>
          <TabsTrigger value="analysis">CSV Analysis</TabsTrigger>
          <TabsTrigger value="research">Research</TabsTrigger>
        </TabsList>

        <TabsContent value="analysis">
          <SectionWrapper>
            <CsvUtilFileUpload />
          </SectionWrapper>

          <SectionWrapper className="bg-[#D3E4FD]/30">
            <AnalysisDashboard />
          </SectionWrapper>
        </TabsContent>

        <TabsContent value="research">
          <SectionWrapper>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <FundResearch />
              </div>
              <div>
                <ExportFundData />
              </div>
            </div>
          </SectionWrapper>
        </TabsContent>
      </Tabs>
    </CsvUtilLayout>
  );
};

export default CsvUtilsPage;
